import { render, staticRenderFns } from "./TopNavigationItem.vue?vue&type=template&id=3d623da0&"
import script from "./TopNavigationItem.vue?vue&type=script&lang=ts&"
export * from "./TopNavigationItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports